import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@material-ui/core';
import React, { VFC } from 'react';
import { FormattedMessage } from 'react-intl';

import { messages } from 'containers/ChatAgent/messages';
import globalMessages from 'shared/global/messages';

import { useConfirmationModalStyles } from '../../styles';

export interface DeleteTopicConfirmationModalProps {
  open: boolean;
  topicName: string;
  onCancel: () => void;
  onConfirm: () => void;
}

export const DeleteTopicConfirmationModal: VFC<
  DeleteTopicConfirmationModalProps
> = ({ open, topicName, onCancel, onConfirm }) => {
  const classes = useConfirmationModalStyles();

  return (
    <Dialog
      open={open}
      onClose={onCancel}
      classes={{ paperScrollPaper: classes.modalContainer }}
    >
      <DialogTitle classes={{ root: classes.modalTitle }}>
        <FormattedMessage {...messages.deleteTopic} />
      </DialogTitle>
      <DialogContent classes={{ root: classes.dialogContent }}>
        <DialogContentText classes={{ root: classes.modalContentText }}>
          <FormattedMessage
            {...messages.deleteTopicConfirmation}
            values={{ topicName }}
          />
        </DialogContentText>
      </DialogContent>
      <DialogActions classes={{ root: classes.dialogActions }}>
        <Button
          onClick={onCancel}
          color="default"
          variant="outlined"
          className={classes.btnCancel}
        >
          <FormattedMessage {...globalMessages.cancel} />
        </Button>
        <Button
          onClick={onConfirm}
          color="secondary"
          variant="outlined"
          className={classes.btnDelete}
        >
          <FormattedMessage {...globalMessages.delete} />
        </Button>
      </DialogActions>
    </Dialog>
  );
};
